import type { Work } from "@/types/catalog";

export const movies: Work[] = [
  {
    id: "m001",
    type: "movie",
    title: "山海归途",
    cover: "https://readdy.ai/api/search-image?query=Cinematic%20movie%20poster%20art%2C%20lone%20traveler%20standing%20on%20a%20misty%20mountain%20ridge%20at%20sunrise%2C%20grand%20epic%20landscape%2C%20deep%20navy%20blue%20and%20warm%20amber%20tones%2C%20dramatic%20volumetric%20light%2C%20painterly%20textured%20illustration%2C%20no%20text&width=600&height=800&seq=movie-poster-001&orientation=portrait",
    banner: "https://readdy.ai/api/search-image?query=Epic%20cinematic%20wide%20shot%20of%20a%20solitary%20traveler%20on%20a%20ridge%20above%20a%20sea%20of%20clouds%20at%20dawn%2C%20deep%20navy%20blue%20sky%20with%20amber%20light%20breaking%20through%2C%20painterly%20atmospheric%20film%20key%20art%2C%20highly%20detailed%2C%20moody%20and%20grand&width=1600&height=900&seq=movie-banner-001&orientation=landscape",
    year: 2024,
    region: "中国大陆",
    genres: ["剧情", "冒险"],
    rating: 8.6,
    duration: "128分钟",
    director: "陈望舒",
    cast: ["沈亦舟", "苏晚棠", "林墨白"],
    description: "少年背负家族旧约，穿越山海寻找传说中的归途。一路上他遇见形形色色的人，也逐渐理解了自己出发的意义。影片以辽阔的自然景观和细腻的人物刻画，讲述一段关于成长、承诺与回家的旅程。",
    views: 486,
    tags: ["年度口碑", "现实主义", "公路"],
    featured: true,
  },
  {
    id: "m002",
    type: "movie",
    title: "深海回声",
    cover: "https://readdy.ai/api/search-image?query=Cinematic%20sci-fi%20movie%20poster%20art%2C%20deep%20ocean%20research%20submersible%20descending%20into%20dark%20trenches%2C%20bioluminescent%20glow%2C%20deep%20teal%20and%20navy%20palette%2C%20mysterious%20suspenseful%20mood%2C%20highly%20detailed%20painterly%20illustration%2C%20no%20text&width=600&height=800&seq=movie-poster-002&orientation=portrait",
    banner: "https://readdy.ai/api/search-image?query=Underwater%20sci-fi%20film%20key%20art%2C%20deep%20sea%20trench%20illuminated%20by%20a%20descending%20submersible%20spotlight%2C%20bioluminescent%20particles%2C%20deep%20blue%20and%20cyan%20glow%2C%20cinematic%20suspenseful%20atmosphere%2C%20ultra%20detailed&width=1600&height=900&seq=movie-banner-002&orientation=landscape",
    year: 2025,
    region: "中国大陆",
    genres: ["科幻", "悬疑"],
    rating: 8.2,
    duration: "136分钟",
    director: "顾星河",
    cast: ["陆沉", "叶知秋", "周砚"],
    description: "一支深海科考队在马里亚纳海沟接收到一段来历不明的声呐信号。随着下潜深度不断增加，队员们发现这段回声似乎来自八十年前一次失踪的航行。真相在幽暗的海底缓缓浮现。",
    views: 512,
    tags: ["科幻", "烧脑", "视效大片"],
    featured: true,
  },
  {
    id: "m003",
    type: "movie",
    title: "长安夜雨",
    cover: "https://readdy.ai/api/search-image?query=Chinese%20historical%20drama%20poster%2C%20ancient%20capital%20city%20street%20in%20rainy%20night%2C%20red%20lanterns%20reflecting%20on%20wet%20stone%2C%20figure%20in%20traditional%20long%20robe%20with%20oil%20paper%20umbrella%2C%20moody%20amber%20and%20navy%20tones%2C%20painterly%20illustration&width=600&height=800&seq=movie-poster-003&orientation=portrait",
    banner: "https://readdy.ai/api/search-image?query=Ancient%20Chinese%20city%20at%20night%20in%20rain%2C%20glowing%20red%20lanterns%20and%20wet%20reflective%20streets%2C%20a%20single%20figure%20with%20umbrella%20walking%20away%2C%20cinematic%20historical%20film%20key%20art%2C%20warm%20amber%20against%20deep%20navy%2C%20highly%20detailed&width=1600&height=900&seq=movie-banner-003&orientation=landscape",
    year: 2023,
    region: "中国大陆",
    genres: ["古装", "爱情"],
    rating: 8.4,
    duration: "118分钟",
    director: "温以宁",
    cast: ["萧承砚", "柳知微", "裴无咎"],
    description: "大唐盛世之下，长安城的一场夜雨，让两个本不该相逢的人相遇。她是背负家族秘密的绣娘，他是执掌禁军的中郎将。一座城，一段情，在风雨飘摇的时局里，他们能否守住彼此的约定。",
    views: 398,
    tags: ["古装", "虐恋", "精美服化"],
  },
  {
    id: "m004",
    type: "movie",
    title: "逆行人生",
    cover: "https://readdy.ai/api/search-image?query=Realistic%20urban%20drama%20movie%20poster%2C%20a%20delivery%20rider%20standing%20in%20a%20busy%20city%20crossroads%20at%20dusk%2C%20warm%20streetlights%20and%20cold%20blue%20buildings%2C%20determined%20expression%2C%20cinematic%20photographic%20style%2C%20painterly%20poster%20art%2C%20no%20text&width=600&height=800&seq=movie-poster-004&orientation=portrait",
    banner: "https://readdy.ai/api/search-image?query=Cinematic%20city%20crossroads%20at%20dusk%20filled%20with%20commuters%20and%20delivery%20riders%2C%20warm%20amber%20streetlights%20against%20deep%20blue%20skyscrapers%2C%20human%20realistic%20drama%20film%20key%20art%2C%20highly%20detailed&width=1600&height=900&seq=movie-banner-004&orientation=landscape",
    year: 2024,
    region: "中国大陆",
    genres: ["剧情", "现实"],
    rating: 8.0,
    duration: "124分钟",
    director: "何砚青",
    cast: ["方致远", "许清和", "郑小满"],
    description: "曾经的互联网中层在中年失业后成为一名外卖骑手。穿过城市的每一条街巷，他重新认识了生活，也重新认识了自己。这是一个关于普通人如何在逆境中保持体面的故事。",
    views: 356,
    tags: ["现实题材", "催泪", "口碑"],
  },
  {
    id: "m005",
    type: "movie",
    title: "星尘旅人",
    cover: "https://readdy.ai/api/search-image?query=Space%20adventure%20movie%20poster%2C%20lone%20astronaut%20floating%20before%20a%20giant%20ringed%20planet%2C%20swirling%20astral%20dust%20and%20nebula%20colors%2C%20deep%20indigo%20and%20warm%20orange%20accents%2C%20epic%20cinematic%20painterly%20illustration%2C%20no%20text&width=600&height=800&seq=movie-poster-005&orientation=portrait",
    banner: "https://readdy.ai/api/search-image?query=Epic%20space%20film%20key%20art%2C%20lone%20astronaut%20silhouette%20before%20an%20enormous%20ringed%20planet%20surrounded%20by%20glowing%20stardust%2C%20deep%20indigo%20nebula%20with%20warm%20orange%20highlights%2C%20grand%20cinematic%20scale%2C%20ultra%20detailed&width=1600&height=900&seq=movie-banner-005&orientation=landscape",
    year: 2025,
    region: "中国大陆",
    genres: ["科幻", "冒险"],
    rating: 7.9,
    duration: "142分钟",
    director: "顾星河",
    cast: ["穆星野", "白露", "江无眠"],
    description: "在人类最后一次深空探索任务中，一名宇航员与地面失联。她只能依靠飞船残存的系统和一段不断重复的神秘广播，穿越星尘寻找回家的坐标。孤独，是宇宙最响亮的回声。",
    views: 442,
    tags: ["硬科幻", "视效", "孤独感"],
  },
  {
    id: "m006",
    type: "movie",
    title: "无声告白",
    cover: "https://readdy.ai/api/search-image?query=Crime%20thriller%20movie%20poster%2C%20rain%20slicked%20alley%20at%20night%20with%20a%20single%20figure%20under%20a%20flickering%20lamp%2C%20cold%20navy%20shadows%20with%20amber%20rim%20light%2C%20tense%20mysterious%20mood%2C%20painterly%20cinematic%20poster%20art%2C%20no%20text&width=600&height=800&seq=movie-poster-006&orientation=portrait",
    banner: "https://readdy.ai/api/search-image?query=Noir%20crime%20thriller%20film%20key%20art%2C%20rain%20slicked%20narrow%20alley%20at%20night%2C%20flickering%20street%20lamp%2C%20lone%20detective%20silhouette%2C%20cold%20blue%20shadows%20with%20amber%20rim%20light%2C%20tense%20atmospheric%20composition%2C%20highly%20detailed&width=1600&height=900&seq=movie-banner-006&orientation=landscape",
    year: 2024,
    region: "中国香港",
    genres: ["犯罪", "悬疑"],
    rating: 8.1,
    duration: "112分钟",
    director: "韦景行",
    cast: ["程亦朗", "苏可颐", "马启铭"],
    description: "一名沉默寡言的老刑警接手了一桩十二年前的悬案。随着证据逐一浮现，他发现真相竟与自己最信任的人有关。有些告白，注定无声，却震耳欲聋。",
    views: 288,
    tags: ["港片", "犯罪", "反转"],
  },
  {
    id: "m007",
    type: "movie",
    title: "夏日回响",
    cover: "https://readdy.ai/api/search-image?query=Coming%20of%20age%20youth%20movie%20poster%2C%20two%20teenagers%20on%20a%20seaside%20pier%20at%20golden%20sunset%2C%20gentle%20warm%20light%2C%20soft%20pastel%20sky%2C%20nostalgic%20bittersweet%20mood%2C%20painterly%20illustration%20poster%20art%2C%20no%20text&width=600&height=800&seq=movie-poster-007&orientation=portrait",
    banner: "https://readdy.ai/api/search-image?query=Nostalgic%20coming%20of%20age%20film%20key%20art%2C%20two%20teenagers%20cycling%20along%20a%20seaside%20road%20at%20golden%20hour%2C%20warm%20amber%20sunlight%20and%20soft%20pastel%20sky%2C%20bittersweet%20summer%20mood%2C%20cinematic%20painterly%20style&width=1600&height=900&seq=movie-banner-007&orientation=landscape",
    year: 2023,
    region: "中国大陆",
    genres: ["青春", "爱情"],
    rating: 7.6,
    duration: "106分钟",
    director: "阮小满",
    cast: ["夏一鸣", "温知夏", "陈屿"],
    description: "南方小城的最后一个夏天，两个少年在蝉鸣与海风里许下约定。多年以后，当他们再次回到那座码头，才发现有些回响从未真正消失，只是被夏天的风藏了起来。",
    views: 234,
    tags: ["青春", "治愈", "夏日"],
  },
  {
    id: "m008",
    type: "movie",
    title: "风暴之眼",
    cover: "https://readdy.ai/api/search-image?query=Disaster%20action%20movie%20poster%2C%20storm%20chaser%20aircraft%20flying%20into%20a%20massive%20hurricane%20wall%2C%20dramatic%20swirling%20clouds%2C%20dark%20navy%20and%20electric%20amber%20tones%2C%20intense%20cinematic%20painterly%20illustration%2C%20no%20text&width=600&height=800&seq=movie-poster-008&orientation=portrait",
    banner: "https://readdy.ai/api/search-image?query=Disaster%20action%20film%20key%20art%2C%20storm%20chaser%20aircraft%20flying%20into%20the%20eye%20wall%20of%20a%20colossal%20hurricane%2C%20swirling%20dark%20clouds%2C%20deep%20navy%20with%20warm%20amber%20light%20breaks%2C%20intense%20cinematic%20scale%2C%20ultra%20detailed&width=1600&height=900&seq=movie-banner-008&orientation=landscape",
    year: 2025,
    region: "中国大陆",
    genres: ["动作", "灾难"],
    rating: 7.5,
    duration: "130分钟",
    director: "雷鸣",
    cast: ["秦越", "安然", "石磊"],
    description: "一场百年不遇的超强台风逼近沿海城市。气象学家与救援队必须在四十八小时内完成史上最大规模的撤离。当风暴之眼缓缓睁开的瞬间，人类的勇气成为最后一道防线。",
    views: 401,
    tags: ["灾难", "动作", "视效"],
  },
  {
    id: "m009",
    type: "movie",
    title: "茶馆旧事",
    cover: "https://readdy.ai/api/search-image?query=Chinese%20period%20drama%20poster%2C%20old%20teahouse%20interior%20with%20warm%20steam%20and%20wooden%20furniture%2C%20elderly%20storyteller%20on%20stage%2C%20sepia%20and%20deep%20navy%20tones%2C%20nostalgic%20painterly%20illustration%2C%20no%20text&width=600&height=800&seq=movie-poster-009&orientation=portrait",
    banner: "https://readdy.ai/api/search-image?query=Nostalgic%20Chinese%20period%20film%20key%20art%2C%20interior%20of%20an%20old%20teahouse%20with%20warm%20steam%20and%20wooden%20furniture%2C%20storyteller%20on%20a%20small%20stage%2C%20sepia%20and%20deep%20navy%20palette%2C%20warm%20nostalgic%20atmosphere%2C%20highly%20detailed&width=1600&height=900&seq=movie-banner-009&orientation=landscape",
    year: 2022,
    region: "中国大陆",
    genres: ["剧情", "年代"],
    rating: 8.8,
    duration: "146分钟",
    director: "温以宁",
    cast: ["老舍言", "周慕云", "宋怀瑾"],
    description: "一间茶馆，三代人，半个世纪的风云变幻。掌柜从少年守到白发，听过无数人的故事，也送走了无数人的背影。旧事如茶，越泡越浓，也越泡越淡。",
    views: 176,
    tags: ["年代", "经典", "高口碑"],
  },
];

export const tvShows: Work[] = [
  {
    id: "t001",
    type: "tv",
    title: "长风渡月",
    cover: "https://readdy.ai/api/search-image?query=Chinese%20costume%20drama%20poster%2C%20young%20general%20in%20elaborate%20armor%20before%20moonlit%20palace%20walls%2C%20flowing%20silk%20robes%2C%20deep%20navy%20and%20warm%20gold%20palette%2C%20elegant%20painterly%20illustration%2C%20no%20text&width=600&height=800&seq=tv-poster-001&orientation=portrait",
    banner: "https://readdy.ai/api/search-image?query=Grand%20Chinese%20palace%20courtyard%20under%20a%20full%20moon%20at%20night%2C%20figure%20in%20flowing%20armor%20and%20silk%20robe%2C%20lanterns%20and%20falling%20petals%2C%20deep%20navy%20and%20warm%20gold%20palette%2C%20epic%20costume%20drama%20key%20art%2C%20highly%20detailed&width=1600&height=900&seq=tv-banner-001&orientation=landscape",
    year: 2024,
    region: "中国大陆",
    genres: ["古装", "权谋"],
    rating: 8.5,
    duration: "全40集",
    director: "沈墨言",
    cast: ["谢长风", "苏渡月", "裴景云"],
    description: "少年将军奉命戍守边关，却卷入一场牵动朝野的权力漩涡。他与聪慧过人的女官联手，在庙堂与沙场之间步步为营，只为守住身后的万家灯火。",
    views: 623,
    tags: ["年度剧王", "权谋", "群像"],
    featured: true,
    episodes: [
      { index: 1, title: "第1集 边关烽火", summary: "长风受命赴边关，途中遇袭，初露锋芒。" },
      { index: 2, title: "第2集 京都来客", summary: "神秘女官渡月奉旨入营，两人初次交锋。" },
      { index: 3, title: "第3集 夜探敌营", summary: "长风孤身探营，发现敌军另有图谋。" },
      { index: 4, title: "第4集 庙堂暗涌", summary: "朝中有人通敌，一封密信浮出水面。" },
      { index: 5, title: "第5集 风起云涌", summary: "边关战事升级，粮草却被截断。" },
      { index: 6, title: "第6集 以身为饵", summary: "渡月设局引蛇出洞，身陷险境。" },
      { index: 7, title: "第7集 月下盟誓", summary: "长风救回渡月，两人立下共守山河之约。" },
      { index: 8, title: "第8集 决战之前", summary: "大战一触即发，真相即将揭晓。" },
    ],
  },
  {
    id: "t002",
    type: "tv",
    title: "都市捕手",
    cover: "https://readdy.ai/api/search-image?query=Urban%20crime%20drama%20poster%2C%20detective%20in%20trench%20coat%20standing%20before%20a%20glowing%20city%20skyline%20at%20night%2C%20cold%20navy%20blue%20with%20amber%20lights%2C%20tense%20modern%20cinematic%20painterly%20art%2C%20no%20text&width=600&height=800&seq=tv-poster-002&orientation=portrait",
    banner: "https://readdy.ai/api/search-image?query=Modern%20city%20skyline%20at%20night%20seen%20from%20a%20rooftop%2C%20lone%20detective%20in%20trench%20coat%20looking%20out%2C%20cold%20navy%20blue%20with%20warm%20amber%20city%20lights%2C%20tense%20urban%20crime%20drama%20key%20art%2C%20highly%20detailed&width=1600&height=900&seq=tv-banner-002&orientation=landscape",
    year: 2025,
    region: "中国大陆",
    genres: ["都市", "刑侦"],
    rating: 8.3,
    duration: "全36集",
    director: "何砚青",
    cast: ["方致远", "许清和", "谭一川"],
    description: "一支特殊的刑侦小队专门负责城市的疑难悬案。队长凭借过人的观察力和共情能力，在每一桩案件背后，寻找被忽略的人性与真相。",
    views: 517,
    tags: ["刑侦", "单元剧", "高能"],
    episodes: [
      { index: 1, title: "第1集 雨夜谜案", summary: "一桩看似意外的雨夜坠楼案，牵出尘封往事。" },
      { index: 2, title: "第2集 消失的证人", summary: "关键证人离奇失踪，线索指向城市另一端。" },
      { index: 3, title: "第3集 双面人生", summary: "受害者竟有两重身份，小队陷入迷雾。" },
      { index: 4, title: "第4集 无声信号", summary: "一段被删除的录音，成为破案关键。" },
      { index: 5, title: "第5集 旧案重提", summary: "十年前的悬案浮出水面，与当前案件相连。" },
      { index: 6, title: "第6集 深夜来客", summary: "神秘访客带来惊人线索，真相近在咫尺。" },
    ],
  },
  {
    id: "t003",
    type: "tv",
    title: "岁月长歌",
    cover: "https://readdy.ai/api/search-image?query=Chinese%20family%20period%20drama%20poster%2C%20family%20gathered%20around%20a%20dinner%20table%20in%20a%20warm%20old%20house%2C%20sepia%20and%20deep%20navy%20tones%2C%20warm%20nostalgic%20painterly%20illustration%2C%20no%20text&width=600&height=800&seq=tv-poster-003&orientation=portrait",
    banner: "https://readdy.ai/api/search-image?query=Nostalgic%20family%20period%20drama%20key%20art%2C%20large%20family%20gathered%20around%20a%20dinner%20table%20in%20a%20warm%20old%20courtyard%20house%2C%20sepia%20and%20deep%20navy%20palette%2C%20warm%20nostalgic%20atmosphere%2C%20highly%20detailed&width=1600&height=900&seq=tv-banner-003&orientation=landscape",
    year: 2023,
    region: "中国大陆",
    genres: ["年代", "家庭"],
    rating: 8.7,
    duration: "全48集",
    director: "温以宁",
    cast: ["周慕云", "宋怀瑾", "老舍言"],
    description: "一个普通家庭跨越四十年的悲欢离合。从计划经济的筒子楼到新世纪的摩天大楼，一家人用各自的方式，唱响属于那个时代的长歌。",
    views: 356,
    tags: ["年代", "家庭", "温情"],
    episodes: [
      { index: 1, title: "第1集 老屋", summary: "一家五口搬进筒子楼，故事从这里开始。" },
      { index: 2, title: "第2集 上山下乡", summary: "长兄响应号召远赴边疆，家书成了牵挂。" },
      { index: 3, title: "第3集 恢复高考", summary: "改变命运的机会来了，兄妹三人各怀心事。" },
      { index: 4, title: "第4集 下海潮", summary: "时代浪潮涌来，二姐决定闯一闯南方。" },
      { index: 5, title: "第5集 团圆饭", summary: "多年后的年夜饭，一家人终于重聚。" },
      { index: 6, title: "第6集 新的开始", summary: "老屋拆迁在即，一家人回望来路。" },
    ],
  },
  {
    id: "t004",
    type: "tv",
    title: "暗夜追凶",
    cover: "https://readdy.ai/api/search-image?query=Suspense%20crime%20series%20poster%2C%20silhouette%20of%20a%20figure%20in%20a%20dark%20corridor%20lit%20by%20a%20single%20lamp%2C%20cold%20blue%20shadows%20with%20amber%20edge%2C%20tense%20mysterious%20painterly%20cinematic%20art%2C%20no%20text&width=600&height=800&seq=tv-poster-004&orientation=portrait",
    banner: "https://readdy.ai/api/search-image?query=Dark%20suspense%20crime%20series%20key%20art%2C%20long%20empty%20corridor%20at%20night%20with%20a%20single%20flickering%20lamp%20and%20a%20distant%20figure%2C%20cold%20blue%20shadows%20with%20amber%20edge%20light%2C%20tense%20ominous%20mood%2C%20highly%20detailed&width=1600&height=900&seq=tv-banner-004&orientation=landscape",
    year: 2024,
    region: "中国大陆",
    genres: ["悬疑", "犯罪"],
    rating: 8.9,
    duration: "全24集",
    director: "韦景行",
    cast: ["程亦朗", "苏可颐", "马启铭"],
    description: "连续发生的案件手法如出一辙，线索却指向警方内部。一名被停职的老刑警与年轻法医联手，在暗夜中追问：真正的凶手，究竟藏在哪一层阴影之后。",
    views: 588,
    tags: ["悬疑", "高分", "烧脑"],
    featured: true,
    episodes: [
      { index: 1, title: "第1集 第一具尸体", summary: "沉寂多年的作案手法再次出现。" },
      { index: 2, title: "第2集 被停职的人", summary: "老刑警被停职，却偷偷展开调查。" },
      { index: 3, title: "第3集 法医笔记", summary: "年轻法医发现尸检报告被人篡改。" },
      { index: 4, title: "第4集 内部名单", summary: "一份加密名单，指向警队高层。" },
      { index: 5, title: "第5集 诱饵", summary: "两人设局引出真凶，却陷入圈套。" },
      { index: 6, title: "第6集 暗夜将明", summary: "真相揭晓，代价沉重。" },
    ],
  },
  {
    id: "t005",
    type: "tv",
    title: "仙途问心",
    cover: "https://readdy.ai/api/search-image?query=Chinese%20xianxia%20fantasy%20poster%2C%20cultivator%20standing%20on%20a%20floating%20mountain%20peak%20surrounded%20by%20clouds%20and%20glowing%20runes%2C%20deep%20indigo%20with%20jade%20and%20warm%20gold%20accents%2C%20ethereal%20painterly%20illustration%2C%20no%20text&width=600&height=800&seq=tv-poster-005&orientation=portrait",
    banner: "https://readdy.ai/api/search-image?query=Chinese%20xianxia%20fantasy%20key%20art%2C%20floating%20mountain%20peaks%20above%20a%20sea%20of%20clouds%2C%20glowing%20celestial%20runes%20and%20sword%20light%2C%20deep%20indigo%20with%20jade%20and%20warm%20gold%20accents%2C%20ethereal%20epic%20scale%2C%20highly%20detailed&width=1600&height=900&seq=tv-banner-005&orientation=landscape",
    year: 2025,
    region: "中国大陆",
    genres: ["仙侠", "奇幻"],
    rating: 8.0,
    duration: "全42集",
    director: "云清和",
    cast: ["白景行", "青梧", "玄真子"],
    description: "一个资质平庸的山门杂役，因一次意外获得上古剑诀。修仙之路漫漫，他逐渐明白，真正要渡的从来不是天劫，而是自己的心。",
    views: 469,
    tags: ["仙侠", "热血", "国风"],
    episodes: [
      { index: 1, title: "第1集 山门杂役", summary: "少年入山门，却只能做最底层的杂役。" },
      { index: 2, title: "第2集 上古剑诀", summary: "一次意外，他触动了封印千年的剑诀。" },
      { index: 3, title: "第3集 初试锋芒", summary: "同门比试，他一鸣惊人。" },
      { index: 4, title: "第4集 心事难明", summary: "剑气入体，心魔悄然滋生。" },
      { index: 5, title: "第5集 问心之劫", summary: "渡劫之日，他必须直面内心的执念。" },
      { index: 6, title: "第6集 剑指苍穹", summary: "真正的仙途，才刚刚开始。" },
    ],
  },
  {
    id: "t006",
    type: "tv",
    title: "人间烟火录",
    cover: "https://readdy.ai/api/search-image?query=Warm%20urban%20life%20series%20poster%2C%20small%20neighborhood%20restaurant%20at%20dusk%20with%20warm%20glowing%20windows%20and%20steam%2C%20cozy%20amber%20and%20soft%20navy%20tones%2C%20gentle%20painterly%20illustration%2C%20no%20text&width=600&height=800&seq=tv-poster-006&orientation=portrait",
    banner: "https://readdy.ai/api/search-image?query=Cozy%20old%20neighborhood%20street%20at%20dusk%20with%20a%20small%20restaurant%20glowing%20warmly%2C%20rising%20steam%20and%20hanging%20lanterns%2C%20warm%20amber%20against%20soft%20navy%20twilight%2C%20gentle%20urban%20life%20drama%20key%20art%2C%20highly%20detailed&width=1600&height=900&seq=tv-banner-006&orientation=landscape",
    year: 2024,
    region: "中国大陆",
    genres: ["都市", "生活"],
    rating: 8.2,
    duration: "全30集",
    director: "阮小满",
    cast: ["陈屿", "温知夏", "夏一鸣"],
    description: "深夜十二点，一家开在巷子口的小面馆准时亮灯。来来往往的客人带着各自的故事，一碗面下肚，人间烟火便有了温度。",
    views: 298,
    tags: ["治愈", "烟火气", "群像"],
    episodes: [
      { index: 1, title: "第1集 深夜面馆", summary: "面馆开张，迎来第一位常客。" },
      { index: 2, title: "第2集 加班的人", summary: "深夜的加班族，一碗面治愈疲惫。" },
      { index: 3, title: "第3集 久别的信", summary: "一封迟到二十年的信，被送到店里。" },
      { index: 4, title: "第4集 无声的告白", summary: "害羞的少年，用一碗面表达心意。" },
      { index: 5, title: "第5集 老街拆迁", summary: "巷子要改造了，面馆面临抉择。" },
      { index: 6, title: "第6集 灯火不灭", summary: "无论身在何处，人间烟火永远温暖。" },
    ],
  },
  {
    id: "t007",
    type: "tv",
    title: "大明风云",
    cover: "https://readdy.ai/api/search-image?query=Chinese%20historical%20epic%20poster%2C%20emperor%20in%20elaborate%20golden%20dragon%20robe%20on%20a%20throne%2C%20deep%20crimson%20and%20navy%20palette%2C%20solemn%20powerful%20painterly%20illustration%2C%20no%20text&width=600&height=800&seq=tv-poster-007&orientation=portrait",
    banner: "https://readdy.ai/api/search-image?query=Grand%20imperial%20throne%20hall%20of%20ancient%20China%2C%20emperor%20in%20golden%20dragon%20robe%20surrounded%20by%20courtiers%2C%20deep%20crimson%20and%20navy%20palette%2C%20solemn%20epic%20historical%20drama%20key%20art%2C%20highly%20detailed&width=1600&height=900&seq=tv-banner-007&orientation=landscape",
    year: 2023,
    region: "中国大陆",
    genres: ["历史", "正剧"],
    rating: 8.6,
    duration: "全50集",
    director: "沈墨言",
    cast: ["朱允言", "徐世昌", "林砚之"],
    description: "从一场朝堂风暴说起，讲述一个王朝由盛转衰的关键二十年。君臣、父子、兄弟，在权力的洪流中各自抉择，留下千古评说。",
    views: 312,
    tags: ["历史", "正剧", "群像"],
    episodes: [
      { index: 1, title: "第1集 朝堂风暴", summary: "新政推行受阻，朝堂暗流涌动。" },
      { index: 2, title: "第2集 君臣之辨", summary: "一场廷议，考验着君臣之间的信任。" },
      { index: 3, title: "第3集 边患未平", summary: "北方告急，主战主和争论不休。" },
      { index: 4, title: "第4集 兄弟阋墙", summary: "夺嫡之争，让手足之情岌岌可危。" },
      { index: 5, title: "第5集 力挽狂澜", summary: "危机时刻，一位老臣挺身而出。" },
      { index: 6, title: "第6集 风云落幕", summary: "一个时代缓缓落下帷幕。" },
    ],
  },
  {
    id: "t008",
    type: "tv",
    title: "少年游",
    cover: "https://readdy.ai/api/search-image?query=Youth%20campus%20drama%20poster%2C%20group%20of%20high%20school%20students%20on%20a%20rooftop%20at%20sunset%20with%20warm%20golden%20light%2C%20fresh%20bright%20pastel%20tones%20and%20soft%20navy%2C%20cheerful%20painterly%20illustration%2C%20no%20text&width=600&height=800&seq=tv-poster-008&orientation=portrait",
    banner: "https://readdy.ai/api/search-image?query=Bright%20youth%20campus%20drama%20key%20art%2C%20group%20of%20students%20running%20across%20a%20sunlit%20school%20field%20at%20golden%20hour%2C%20fresh%20warm%20pastel%20tones%20with%20soft%20navy%20shadows%2C%20energetic%20nostalgic%20mood%2C%20highly%20detailed&width=1600&height=900&seq=tv-banner-008&orientation=landscape",
    year: 2025,
    region: "中国大陆",
    genres: ["青春", "校园"],
    rating: 7.8,
    duration: "全28集",
    director: "阮小满",
    cast: ["夏一鸣", "温知夏", "林小满"],
    description: "一群性格迥异的高中生，在最张扬的年纪相遇。他们一起经历考试、比赛、离别与和解，把青春过成了彼此最难忘的一页。",
    views: 267,
    tags: ["青春", "校园", "热血"],
    episodes: [
      { index: 1, title: "第1集 开学第一天", summary: "新学期开始，一群少年意外成为同桌。" },
      { index: 2, title: "第2集 班级对抗", summary: "一场篮球赛，点燃了全班的热血。" },
      { index: 3, title: "第3集 少年心事", summary: "藏在课本里的纸条，道出青涩心事。" },
      { index: 4, title: "第4集 期中风暴", summary: "成绩公布，有人欢喜有人忧。" },
      { index: 5, title: "第5集 社团之争", summary: "为保住社团，一场创意比拼展开。" },
      { index: 6, title: "第6集 不说再见", summary: "毕业在即，他们许下未来之约。" },
    ],
  },
  {
    id: "t009",
    type: "tv",
    title: "棋局",
    cover: "https://readdy.ai/api/search-image?query=Business%20thriller%20drama%20poster%2C%20executive%20silhouette%20before%20a%20giant%20glass%20tower%20at%20night%2C%20chessboard%20reflection%2C%20deep%20navy%20and%20amber%20accents%2C%20sharp%20cinematic%20painterly%20art%2C%20no%20text&width=600&height=800&seq=tv-poster-009&orientation=portrait",
    banner: "https://readdy.ai/api/search-image?query=Business%20thriller%20series%20key%20art%2C%20glass%20skyscraper%20at%20night%20reflecting%20a%20giant%20chessboard%2C%20lone%20executive%20silhouette%2C%20deep%20navy%20blue%20with%20amber%20accents%2C%20sharp%20tense%20cinematic%20mood%2C%20highly%20detailed&width=1600&height=900&seq=tv-banner-009&orientation=landscape",
    year: 2024,
    region: "中国大陆",
    genres: ["商战", "悬疑"],
    rating: 8.1,
    duration: "全32集",
    director: "雷鸣",
    cast: ["秦越", "安然", "石磊"],
    description: "一场百亿并购案的背后，是资本与人性的博弈。年轻的分析师无意间发现棋局中的破绽，从此被卷入一场关于野心、背叛与救赎的较量。",
    views: 341,
    tags: ["商战", "烧脑", "反转"],
    episodes: [
      { index: 1, title: "第1集 百亿并购", summary: "一场并购启动，各方势力登场。" },
      { index: 2, title: "第2集 暗流", summary: "分析师发现数据中的异常。" },
      { index: 3, title: "第3集 棋手", summary: "幕后的操盘手逐渐浮出水面。" },
      { index: 4, title: "第4集 弃子", summary: "有人被牺牲，有人开始反击。" },
      { index: 5, title: "第5集 将军", summary: "关键一步落子，局势逆转。" },
      { index: 6, title: "第6集 终局", summary: "棋局终了，人心初现。" },
    ],
  },
];

export const varietyShows: Work[] = [
  {
    id: "v001",
    type: "variety",
    title: "星光大赏",
    cover: "https://readdy.ai/api/search-image?query=Music%20awards%20show%20poster%2C%20dazzling%20stage%20with%20spotlights%20and%20confetti%2C%20singer%20silhouette%20under%20a%20shower%20of%20golden%20light%2C%20deep%20navy%20with%20warm%20amber%20sparkle%2C%20glamorous%20painterly%20illustration%2C%20no%20text&width=600&height=800&seq=variety-poster-001&orientation=portrait",
    banner: "https://readdy.ai/api/search-image?query=Dazzling%20music%20awards%20stage%20with%20golden%20spotlights%2C%20confetti%20and%20light%20beams%2C%20performer%20silhouette%20surrounded%20by%20warm%20amber%20glow%20against%20deep%20navy%2C%20glamorous%20energetic%20concert%20key%20art%2C%20highly%20detailed&width=1600&height=900&seq=variety-banner-001&orientation=landscape",
    year: 2025,
    region: "中国大陆",
    genres: ["音乐", "真人秀"],
    rating: 8.4,
    duration: "每周五 20:00",
    director: "刘一鸣",
    cast: ["华语群星", "特邀导师团"],
    description: "年度最具影响力的音乐盛典。顶尖歌手与新锐唱作人同台竞演，用一场场舞台表演点燃整个夏天。每一期都有惊喜嘉宾与高能现场。",
    views: 712,
    tags: ["音乐", "盛典", "高热度"],
    featured: true,
    episodes: [
      { index: 1, title: "第一期 开场之夜", summary: "群星集结，开场舞台震撼全场。" },
      { index: 2, title: "第二期 经典重唱", summary: "歌手重新演绎华语经典金曲。" },
      { index: 3, title: "第三期 跨界合作", summary: "歌手与乐队、舞者跨界同台。" },
      { index: 4, title: "第四期 原创之夜", summary: "新锐唱作人带来原创作品。" },
      { index: 5, title: "第五期 巅峰对决", summary: "强强对话，舞台火药味十足。" },
      { index: 6, title: "第六期 年度盛典", summary: "年度舞台揭晓，全场沸腾。" },
    ],
  },
  {
    id: "v002",
    type: "variety",
    title: "快乐向前冲",
    cover: "https://readdy.ai/api/search-image?query=Fun%20outdoor%20game%20show%20poster%2C%20contestants%20racing%20through%20colorful%20inflatable%20obstacles%2C%20bright%20lively%20tones%20of%20orange%20and%20navy%2C%20playful%20energetic%20painterly%20illustration%2C%20no%20text&width=600&height=800&seq=variety-poster-002&orientation=portrait",
    banner: "https://readdy.ai/api/search-image?query=Energetic%20outdoor%20game%20show%20key%20art%2C%20contestants%20racing%20through%20colorful%20inflatable%20obstacles%20over%20water%2C%20bright%20lively%20orange%20and%20navy%20tones%2C%20playful%20fun%20summer%20atmosphere%2C%20highly%20detailed&width=1600&height=900&seq=variety-banner-002&orientation=landscape",
    year: 2024,
    region: "中国大陆",
    genres: ["竞技", "游戏"],
    rating: 7.9,
    duration: "每周六 19:30",
    director: "赵小北",
    cast: ["快乐家族", "飞行嘉宾"],
    description: "全民参与的大型户外竞技综艺。素人与明星组队闯关，在欢笑与汗水中挑战极限。没有永远的赢家，只有不服输的快乐。",
    views: 534,
    tags: ["竞技", "搞笑", "合家欢"],
    episodes: [
      { index: 1, title: "第一期 水上闯关", summary: "经典水上赛道回归，笑料不断。" },
      { index: 2, title: "第二期 城市探秘", summary: "转战城市街头，任务全新升级。" },
      { index: 3, title: "第三期 团队对抗", summary: "分队对抗，配合与策略缺一不可。" },
      { index: 4, title: "第四期 深夜挑战", summary: "夜场挑战开启，气氛紧张刺激。" },
      { index: 5, title: "第五期 冠军之夜", summary: "总冠军花落谁家，悬念揭晓。" },
    ],
  },
  {
    id: "v003",
    type: "variety",
    title: "向往的生活季",
    cover: "https://readdy.ai/api/search-image?query=Slow%20life%20reality%20show%20poster%2C%20cozy%20rural%20farmhouse%20with%20vegetable%20garden%20and%20smoke%20from%20chimney%20at%20dusk%2C%20warm%20amber%20and%20soft%20green%20navy%20tones%2C%20peaceful%20painterly%20illustration%2C%20no%20text&width=600&height=800&seq=variety-poster-003&orientation=portrait",
    banner: "https://readdy.ai/api/search-image?query=Peaceful%20rural%20farmhouse%20surrounded%20by%20vegetable%20gardens%20and%20mountains%20at%20dusk%2C%20warm%20amber%20light%20from%20windows%20and%20chimney%20smoke%2C%20soft%20green%20and%20navy%20tones%2C%20serene%20slow%20life%20key%20art%2C%20highly%20detailed&width=1600&height=900&seq=variety-banner-003&orientation=landscape",
    year: 2025,
    region: "中国大陆",
    genres: ["生活", "慢综艺"],
    rating: 8.5,
    duration: "每周日 21:00",
    director: "孙牧野",
    cast: ["何老师", "黄小厨", "彭彭"],
    description: "回到乡野，种菜、做饭、招待朋友。没有剧本，只有四季更替与一日三餐。看嘉宾们在慢下来的时光里，重新找回生活的滋味。",
    views: 486,
    tags: ["慢综艺", "治愈", "烟火气"],
    episodes: [
      { index: 1, title: "第一期 归园田居", summary: "蘑菇屋重新开张，嘉宾陆续到访。" },
      { index: 2, title: "第二期 春耕时节", summary: "一起下地插秧，体验农耕之乐。" },
      { index: 3, title: "第三期 老友重逢", summary: "多年老友相聚，围炉夜话。" },
      { index: 4, title: "第四期 丰收之夜", summary: "菜园丰收，摆一桌田园盛宴。" },
      { index: 5, title: "第五期 送别与相遇", summary: "有相聚就有离别，温情满满。" },
    ],
  },
  {
    id: "v004",
    type: "variety",
    title: "脱口秀之夜",
    cover: "https://readdy.ai/api/search-image?query=Stand-up%20comedy%20show%20poster%2C%20comedian%20with%20microphone%20on%20a%20spotlit%20stage%2C%20warm%20amber%20spotlight%20against%20deep%20navy%20backdrop%2C%20clean%20modern%20playful%20painterly%20illustration%2C%20no%20text&width=600&height=800&seq=variety-poster-004&orientation=portrait",
    banner: "https://readdy.ai/api/search-image?query=Stand-up%20comedy%20stage%20key%20art%2C%20comedian%20silhouette%20holding%20a%20microphone%20under%20a%20single%20warm%20amber%20spotlight%2C%20deep%20navy%20backdrop%20with%20scattered%20audience%20silhouettes%2C%20playful%20modern%20mood%2C%20highly%20detailed&width=1600&height=900&seq=variety-banner-004&orientation=landscape",
    year: 2024,
    region: "中国大陆",
    genres: ["喜剧", "语言"],
    rating: 8.3,
    duration: "每周四 20:00",
    director: "李诞诞",
    cast: ["脱口秀演员团", "特邀嘉宾"],
    description: "一群把生活讲成段子的人，用最真诚的方式调侃世界。台上三分钟，台下无数个深夜的打磨。笑声背后，是对生活的洞察与和解。",
    views: 452,
    tags: ["喜剧", "语言类", "高口碑"],
    episodes: [
      { index: 1, title: "第一期 生活观察", summary: "从日常小事开刀，笑声不断。" },
      { index: 2, title: "第二期 职场专场", summary: "打工人的心声，句句扎心。" },
      { index: 3, title: "第三期 情感专场", summary: "聊爱情与亲情，笑中带泪。" },
      { index: 4, title: "第四期 城市专场", summary: "不同城市的年轻人，不同的烦恼。" },
      { index: 5, title: "第五期 年终盛典", summary: "年度段子盘点，全场爆笑。" },
    ],
  },
  {
    id: "v005",
    type: "variety",
    title: "美食奇遇记",
    cover: "https://readdy.ai/api/search-image?query=Food%20travel%20show%20poster%2C%20steaming%20bowls%20of%20regional%20Chinese%20dishes%20on%20a%20wooden%20table%20with%20warm%20lantern%20light%2C%20rich%20amber%20and%20deep%20navy%20tones%2C%20appetizing%20painterly%20illustration%2C%20no%20text&width=600&height=800&seq=variety-poster-005&orientation=portrait",
    banner: "https://readdy.ai/api/search-image?query=Appetizing%20food%20travel%20show%20key%20art%2C%20spread%20of%20regional%20Chinese%20dishes%20on%20a%20rustic%20wooden%20table%20with%20steam%20and%20warm%20lantern%20light%2C%20rich%20amber%20and%20deep%20navy%20tones%2C%20mouthwatering%20mood%2C%20highly%20detailed&width=1600&height=900&seq=variety-banner-005&orientation=landscape",
    year: 2025,
    region: "中国大陆",
    genres: ["美食", "文化"],
    rating: 8.6,
    duration: "每周三 18:00",
    director: "陈一味",
    cast: ["美食探索团"],
    description: "走遍大江南北，只为寻一口地道风味。从街边小摊到百年老店，每道菜背后都有一位坚守的手艺人，和一段值得被记住的故事。",
    views: 398,
    tags: ["美食", "人文", "治愈"],
    episodes: [
      { index: 1, title: "第一期 山城麻辣", summary: "深入山城，探寻地道麻辣风味。" },
      { index: 2, title: "第二期 江南早茶", summary: "一盅两件，品味江南的清晨。" },
      { index: 3, title: "第三期 西北面食", summary: "一碗面里的西北豪情。" },
      { index: 4, title: "第四期 沿海鲜味", summary: "出海寻鲜，尝尽海洋馈赠。" },
      { index: 5, title: "第五期 家宴", summary: "一桌团圆饭，最是人间至味。" },
    ],
  },
  {
    id: "v006",
    type: "variety",
    title: "舞台之王",
    cover: "https://readdy.ai/api/search-image?query=Dance%20competition%20show%20poster%2C%20dancer%20mid-air%20in%20a%20dynamic%20pose%20under%20dramatic%20spotlights%2C%20motion%20blur%20and%20warm%20amber%20glow%20against%20deep%20navy%2C%20energetic%20painterly%20illustration%2C%20no%20text&width=600&height=800&seq=variety-poster-006&orientation=portrait",
    banner: "https://readdy.ai/api/search-image?query=Dance%20competition%20show%20key%20art%2C%20group%20of%20dancers%20in%20dynamic%20mid-air%20poses%20under%20dramatic%20stage%20spotlights%2C%20warm%20amber%20glow%20and%20motion%20against%20deep%20navy%2C%20high%20energy%20mood%2C%20highly%20detailed&width=1600&height=900&seq=variety-banner-006&orientation=landscape",
    year: 2024,
    region: "中国大陆",
    genres: ["舞蹈", "竞技"],
    rating: 8.1,
    duration: "每周五 21:30",
    director: "叶知秋",
    cast: ["街舞舞者", "明星领队"],
    description: "顶尖舞者的竞技舞台，从街舞到现代舞，用身体讲述故事。每一次battle都火花四溅，每一支作品都值得反复回味。",
    views: 366,
    tags: ["舞蹈", "竞技", "热血"],
    episodes: [
      { index: 1, title: "第一期 集结", summary: "各地舞者集结，初舞台亮相。" },
      { index: 2, title: "第二期 组队battle", summary: "抽签组队，正面battle火药味十足。" },
      { index: 3, title: "第三期 命题作品", summary: "抽到命题，考验编舞与表达。" },
      { index: 4, title: "第四期 跨界合作", summary: "与音乐人合作，舞台全面升级。" },
      { index: 5, title: "第五期 冠军之夜", summary: "巅峰对决，舞台之王诞生。" },
    ],
  },
  {
    id: "v007",
    type: "variety",
    title: "一起去旅行",
    cover: "https://readdy.ai/api/search-image?query=Travel%20reality%20show%20poster%2C%20group%20of%20friends%20with%20backpacks%20on%20a%20scenic%20mountain%20road%20at%20golden%20sunset%2C%20warm%20amber%20and%20deep%20navy%20tones%2C%20joyful%20painterly%20illustration%2C%20no%20text&width=600&height=800&seq=variety-poster-007&orientation=portrait",
    banner: "https://readdy.ai/api/search-image?query=Travel%20reality%20show%20key%20art%2C%20group%20of%20friends%20hiking%20a%20scenic%20coastal%20mountain%20road%20at%20golden%20sunset%2C%20warm%20amber%20light%20and%20deep%20navy%20shadows%2C%20joyful%20adventurous%20mood%2C%20highly%20detailed&width=1600&height=900&seq=variety-banner-007&orientation=landscape",
    year: 2025,
    region: "中国大陆",
    genres: ["旅行", "真人秀"],
    rating: 8.0,
    duration: "每周二 20:00",
    director: "林远行",
    cast: ["旅行团", "飞行嘉宾"],
    description: "一群好友结伴出发，用有限预算走遍山川湖海。旅途中有惊喜也有意外，最好的风景，永远是与同伴一起看的那一眼。",
    views: 322,
    tags: ["旅行", "治愈", "好友"],
    episodes: [
      { index: 1, title: "第一期 出发", summary: "抽签决定目的地，旅程拉开帷幕。" },
      { index: 2, title: "第二期 山海之间", summary: "沿海公路自驾，风景美不胜收。" },
      { index: 3, title: "第三期 古城漫游", summary: "走进古城，感受烟火与人情。" },
      { index: 4, title: "第四期 高原之上", summary: "挑战高海拔，收获绝美星空。" },
      { index: 5, title: "第五期 归途", summary: "旅程尾声，写下各自的感悟。" },
    ],
  },
  {
    id: "v008",
    type: "variety",
    title: "少年说唱",
    cover: "https://readdy.ai/api/search-image?query=Hip-hop%20music%20competition%20show%20poster%2C%20young%20rapper%20with%20microphone%20under%20urban%20neon%20lights%2C%20warm%20amber%20and%20deep%20navy%20with%20orange%20graffiti%20tones%2C%20bold%20street%20painterly%20illustration%2C%20no%20text&width=600&height=800&seq=variety-poster-008&orientation=portrait",
    banner: "https://readdy.ai/api/search-image?query=Hip-hop%20competition%20show%20key%20art%2C%20young%20rapper%20on%20an%20urban%20rooftop%20stage%20with%20graffiti%20walls%20and%20warm%20neon%20glow%20against%20deep%20navy%20night%20city%2C%20bold%20energetic%20street%20mood%2C%20highly%20detailed&width=1600&height=900&seq=variety-banner-008&orientation=landscape",
    year: 2024,
    region: "中国大陆",
    genres: ["音乐", "说唱"],
    rating: 8.2,
    duration: "每周六 21:00",
    director: "热狗哥",
    cast: ["说唱厂牌团", "明星制作人"],
    description: "来自全国的说唱新势力同台竞技，用flow和态度表达属于这个时代的声音。从地下到舞台，每一个verse都掷地有声。",
    views: 428,
    tags: ["说唱", "音乐", "热血"],
    episodes: [
      { index: 1, title: "第一期 海选", summary: "全国海选开启，新势力登场。" },
      { index: 2, title: "第二期 一对一", summary: "一对一battle，实力见真章。" },
      { index: 3, title: "第三期 主题创作", summary: "限时创作，考验真实功力。" },
      { index: 4, title: "第四期 制作人合作", summary: "与制作人合作，作品全面升级。" },
      { index: 5, title: "第五期 总决赛", summary: "年度说唱新星诞生。" },
    ],
  },
];

export const allWorks: Work[] = [...movies, ...tvShows, ...varietyShows];